/**
 * Server recorder sessions this app has already asked to stop.
 *
 * Several things end a VideoMail take on the server recorder: the Stop button
 * (VideoMailGreetingRecordingOverlay), Discard, Record again, leaving the
 * room, and the length limit (voicemail/middleware.ts). The recorder must be
 * asked once per session; a second stop while the first is being finalized
 * is refused by the recorder and reported to the person as a failure.
 */
const requested = new Set();
export function hasRequestedRecorderStop(sessionId) {
    return requested.has(sessionId);
}
export function noteRecorderStopRequested(sessionId) {
    requested.add(sessionId);
}
